export default __webpack_public_path__ + "static/media/Related_Link_-_bids_thumbnail_image_-Resized.93a8c6bb.jpg";